var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6001 20.4004C3.6001 19.7376 4.13736 19.2004 4.8001 19.2004H19.2001C19.8628 19.2004 20.4001 19.7377 20.4001 20.4004C20.4001 21.0631 19.8628 21.6004 19.2001 21.6004H4.8001C4.13736 21.6004 3.6001 21.0631 3.6001 20.4004ZM7.55157 11.1519C8.0202 10.6832 8.78 10.6832 9.24862 11.1519L10.8001 12.7033L10.8001 3.60039C10.8001 2.93765 11.3374 2.40039 12.0001 2.40039C12.6628 2.40039 13.2001 2.93765 13.2001 3.60039L13.2001 12.7033L14.7516 11.1519C15.2202 10.6832 15.98 10.6832 16.4486 11.1519C16.9173 11.6205 16.9173 12.3803 16.4486 12.8489L12.8486 16.4489C12.6236 16.674 12.3184 16.8004 12.0001 16.8004C11.6818 16.8004 11.3766 16.674 11.1516 16.4489L7.55157 12.8489C7.08294 12.3803 7.08294 11.6205 7.55157 11.1519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowWhite);
export default __webpack_public_path__ + "static/media/down-arrow-white.45bacb1524b135d2f10978c555f6a159.svg";
export { ForwardRef as ReactComponent };